<template>
  <div class="downloadApp">
    <div class="downloadApp__logo"></div>
    <div class="downloadApp__name">{{ $t('elfinbook_yifei') }}</div>
    <div class="downloadApp__intr">{{ $t('_app_feature') }}</div>
    <div class="downloadApp__btn" @click="downloadApp">
      {{ $t('download_app') }}
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    downloadApp() {
      window.report && window.report('ShareDoc_DownloadApp');
      window.location.href =
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.qihui.elfinbook&ckey=CK1475858254760';
    }
  }
};
</script>

<style scoped>
.downloadApp {
  height: 0.5rem;
  background: #fff;
  padding: 0 0.16rem;
  overflow: hidden;
}
.downloadApp__logo {
  float: left;
  width: 0.4rem;
  height: 0.4rem;
  margin-top: 0.05rem;
  margin-right: 0.06rem;
  background: url(~@/assets/image/minip_app_icon_logo@2x.png) no-repeat 0 0 /
    0.4rem 0.4rem;
}
.downloadApp__name {
  /* float: left; */
  font-size: 0.16rem;
  font-weight: bold;
  margin-top: 0.06rem;
}
.downloadApp__intr {
  /* float: left; */
  font-size: 0.12rem;
  color: #666;
}
.downloadApp__btn {
  position: absolute;
  right: 0.16rem;
  top: 0.1rem;
  text-align: center;
  line-height: 0.3rem;
  height: 0.3rem;
  background: #0dcbb8;
  border-radius: 0.15rem;
  padding: 0 0.08rem;
  color: #fff;
  font-weight: bold;
}
</style>
